import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { showResult } from 'infrastructure/hooks/utils';
import MasterModal from 'components/organisms/masterModal';

import s from './styles.module.scss';

const DischargePatientModal = ({
  isOpen,
  toggle,
  patientGuid,
  options,
  loading,
  submit,
  modalType = 'rpm',
}) => {
  const {
    patient: { getDetails },
    patientStatusLogs: { getPatientStatusLogs },
  } = useDispatch();

  const formRef = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const buttonLabel = modalType === 'rpm' ? 'Discharge' : 'Unenroll';

  const handleSubmit = async (values) => {
    const postData = {
      patientGuid,
      dischargeStatus: values.status,
    };
    const { error } = await submit(postData);
    await getDetails(patientGuid);
    await getPatientStatusLogs(patientGuid);
    showResult(error, null, null, toggle);
  };

  return (
    <>
      {isOpen && (
        <MasterModal
          title="Status"
          isOpen={isOpen}
          toggle={toggle}
          size="default"
          saveLabel={buttonLabel}
          isSaveLoading={loading}
          isSaveDisabled={!isDirty}
          onSave={() => formRef.current?.submitForm()}
          bodyClassName={s['modal-body']}
        >
          <Formik
            innerRef={formRef}
            initialValues={{ status: '' }}
            onSubmit={handleSubmit}
          >
            {({ dirty }) => {
              if (dirty !== isDirty) setIsDirty(dirty);
              return (
                <Form>
                  <FormGroup tag="fieldset">
                    {options.map((option) => (
                      <FormGroup check key={option.id}>
                        <Label check>
                          <Field
                            className="form-check-input"
                            type="radio"
                            name="status"
                            value={option.id}
                            disabled={loading}
                          />
                          {option.label}
                        </Label>
                      </FormGroup>
                    ))}
                  </FormGroup>
                </Form>
              );
            }}
          </Formik>
        </MasterModal>
      )}
    </>
  );
};

DischargePatientModal.defaultProps = {
  isOpen: false,
};

DischargePatientModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  submit: PropTypes.func.isRequired,
  modalType: PropTypes.string,
};

export default DischargePatientModal;
